import Vue from 'vue'
import Router from 'vue-router'
import store from '@/stores/store.js'
import { routeRegistPath } from '@/main.js'

// Containers
import Full from '@/containers/Full'

// Views - Pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'

import Login from '@/components/Login'
import Home from '@/components/Home'
import Register from '@/components/Register'
import Reset from '@/components/Reset'
import LoginByADFS from '@/components/LoginByADFS'

// User
import Profile from '@/views/user/Profile'
import ProfileRegist from '@/views/user/ProfileRegist'
import User from '@/views/user/User'

// OKR
import OkrList from '@/views/okr/OkrList'
import ObjectiveRegist from '@/views/okr/ObjectiveRegist'
import KeyresultRegist from '@/views/okr/KeyresultRegist'
import OkrComplete from '@/views/okr/OkrComplete'
import ProxyOkr from '@/views/okr/ProxyOkr'
// 1on1
import OneList from '@/views/one/OneList'
import OneRegist from '@/views/one/OneRegist'
import OneRequest from '@/views/one/OneRequest'
import OneRequestSent from '@/views/one/OneRequestSent'
// import OneRequestRece from '@/views/one/OneRequestRece'

// FbRequest
import FbRequestList from '@/views/fb/FbRequestList'
import FbRegist from '@/views/fb/FbRegist'

// Notice
import NoticeList from '@/views/notice/NoticeList'
import NoticeSetting from '@/views/notice/NoticeSetting'
import OneRequestRece from '@/views/notice/OneRequestRece'
import NoticeSettingDetail from '@/views/notice/NoticeSettingDetail'

// People
import UserSearch from '@/views/people/UserSearch'
import GroupList from '@/views/people/GroupList'
import OrganizationList from '@/views/people/OrganizationList'
import GroupRegist from '@/views/people/GroupRegist'

// WebView
import Help from '@/views/webview/Help'
import Terms from '@/views/webview/Terms'
import ResetPassword from '@/views/webview/ResetPassword'
import TermsTrendmicro from '@/views/webview/TermsTrendmicro'
import TermsTrendmicroNg from '@/views/webview/TermsTrendmicroNg'
// Views - WebView
import WebViewIndex from '@/views/_webview/WebViewIndex'
import WebViewTermsJA from '@/views/_webview/WebViewTermsJA'
import WebViewTermsEN from '@/views/_webview/WebViewTermsEN'
import WebViewTermsZH from '@/views/_webview/WebViewTermsZH'
import WebViewHelpsJA from '@/views/_webview/WebViewHelpsJA'
import WebViewHelpsEN from '@/views/_webview/WebViewHelpsEN'
import WebViewHelpsZH from '@/views/_webview/WebViewHelpsZH'
import LiteWebViewHelpsJA from '@/views/_webview/LiteWebViewHelpsJA'
import LiteWebViewHelpsEN from '@/views/_webview/LiteWebViewHelpsEN'
import LiteWebViewHelpsZH from '@/views/_webview/LiteWebViewHelpsZH'

import WebViewTermsTrendmicroJA from '@/views/_webview/WebViewTermsTrendmicroJA'
import WebViewTermsTrendmicroEN from '@/views/_webview/WebViewTermsTrendmicroEN'
import WebViewTermsTrendmicroZH from '@/views/_webview/WebViewTermsTrendmicroZH'
import WebViewTermsTrendmicroNgJA from '@/views/_webview/WebViewTermsTrendmicroNgJA'
import WebViewTermsTrendmicroNgEN from '@/views/_webview/WebViewTermsTrendmicroNgEN'
import WebViewTermsTrendmicroNgZH from '@/views/_webview/WebViewTermsTrendmicroNgZH'

// Report
import Report from '@/views/report/Report'
import ReportRelations from '@/views/report/ReportRelations'
import Report1on1s from '@/views/report/Report1on1s'
import ReportActivity from '@/views/report/ReportActivity'

// Manage
import ManageOkrSelect from '@/views/manage/ManageOkrSelect'
import ManageOkrTree from '@/views/manage/ManageOkrTree'
import Manage from '@/views/manage/Manage'
import ManageUsers from '@/views/manage/ManageUsers'
import ManageEmails from '@/views/manage/ManageEmails'
import ManageItems from '@/views/manage/ManageItems'
import ManageUserSearch from '@/views/manage/ManageUserSearch'
import ManageGroups from '@/views/manage/ManageGroups'
import ManageOrganization from '@/views/manage/ManageOrganization'
import ManageGroupEdit from '@/views/manage/ManageGroupEdit'
import OrganizationEdit from '@/views/manage/OrganizationEdit'
import OkrNetwork from '@/views/manage/OkrNetwork'
import firebaseApp from './../firebase-setup'

Vue.use(Router)
let project = ''
if (process.env) {
  if (process.env.FIREBASE_PROJECT) {
    switch (process.env.FIREBASE_PROJECT) {
      case 'trendmicro':
      case 'trendmicroNg':
        project = process.env.FIREBASE_PROJECT
        break
      default:
        break
    }
  }
}

console.log('project', project)
let router = new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/home',
      name: 'Home',
      component: Full,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/okr',
          redirect: '/okr/list',
          name: 'okr',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'OkrList',
              component: OkrList
            },
            {
              path: 'objective-regist',
              name: 'ObjectiveRegist',
              component: ObjectiveRegist
            },
            {
              path: 'keyresult-regist',
              name: 'KeyresultRegist',
              component: KeyresultRegist
            },
            {
              path: 'complete',
              name: 'OkrComplete',
              component: OkrComplete
            },
            {
              path: 'okr-network',
              name: 'OkrNetwork',
              component: OkrNetwork
            },
            {
              path: 'proxy',
              name: 'ProxyOkr',
              component: ProxyOkr
            }
          ]
        },
        {
          path: '/one',
          redirect: '/one/list',
          name: 'one',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'OneList',
              component: OneList
            },
            {
              path: 'regist',
              name: 'OneRegist',
              component: OneRegist
            },
            {
              path: 'request',
              name: 'OneRequest',
              component: OneRequest
            },
            {
              path: 'request-sent',
              name: 'OneRequestSent',
              component: OneRequestSent
            }
          ]
        },
        {
          path: '/fb',
          redirect: '/fb/list',
          name: 'fb',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'FbRequestList',
              component: FbRequestList
            },
            {
              path: 'regist',
              name: 'FbRegist',
              component: FbRegist
            }
          ]
        },
        {
          path: '/notice',
          redirect: '/notice/list',
          name: 'notice',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'NoticeList',
              component: NoticeList
            },
            {
              path: 'setting',
              name: 'NoticeSetting',
              component: NoticeSetting
            },
            {
              path: 'request-rece',
              name: 'OneRequestRece',
              component: OneRequestRece
            },
            {
              path: 'setting-detail',
              name: 'NoticeSettingDetail',
              component: NoticeSettingDetail

            }
          ]
        },
        {
          path: '/people',
          redirect: '/people/search',
          name: 'people',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'search',
              name: 'UserSearch',
              component: UserSearch
            },
            {
              path: 'group-list',
              name: 'GroupList',
              component: GroupList
            },
            {
              path: 'organization-list',
              name: 'OrganizationList',
              component: OrganizationList
            },
            {
              path: 'group-regist',
              name: 'GroupRegist',
              component: GroupRegist
            }
          ]
        },
        {
          path: '/profile',
          // redirect: '/profile',
          name: 'profile',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/',
              name: 'Profile',
              component: Profile
            },
            {
              path: 'regist',
              name: 'ProfileRegist',
              component: ProfileRegist
            }
          ]
        },
        {
          path: '/user',
          // redirect: '/user/:userId',
          // redirect: '/profile',
          name: ':userId',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ':userId',
              name: 'User',
              component: User
            }
          ]
        },
        {
          path: '/config',
          redirect: '/config/help',
          name: 'help',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'help',
              name: 'Help',
              component: Help
            },
            {
              path: 'terms',
              name: 'Terms',
              component: (project === 'trendmicro') ? TermsTrendmicro : (project === 'trendmicroNg') ? TermsTrendmicroNg : Terms
            },
            {
              path: 'reset',
              name: 'ResetPassword',
              component: ResetPassword
            }
          ]
        },
        {
          path: '/report',
          redirect: '/report/dashboard',
          name: 'report',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'dashboard',
              name: 'Report',
              component: Report
            },
            {
              path: 'relations',
              name: 'ReportRelations',
              component: ReportRelations
            },
            {
              path: '1on1s',
              name: 'Report1on1s',
              component: Report1on1s
            }
          ]
        },
        {
          path: '/manage',
          redirect: '/manage/dashboard',
          name: 'manage',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'activity',
              name: 'ReportActivity',
              component: ReportActivity
            },
            {
              path: 'dashboard',
              name: 'Manage',
              component: Manage
            },
            {
              path: 'users',
              name: 'ManageUsers',
              component: ManageUsers
            },
            {
              path: 'groups',
              name: 'ManageGroups',
              component: ManageGroups
            },
            {
              path: 'organization',
              name: 'ManageOrganization',
              component: ManageOrganization
            },
            {
              path: 'emails',
              name: 'ManageEmails',
              component: ManageEmails
            },
            {
              path: 'search',
              name: 'ManageUserSearch',
              component: ManageUserSearch
            },
            {
              path: 'items',
              name: 'ManageItems',
              component: ManageItems
            },
            {
              path: 'groupedit',
              name: 'ManageGroupEdit',
              component: ManageGroupEdit
            },
            {
              path: 'organizationedit',
              name: 'OrganizationEdit',
              component: OrganizationEdit
            },
            {
              path: '/okrTree',
              // redirect: '/user/:userId',
              // redirect: '/profile',
              name: ':itemId',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: ':userId/:itemId',
                  name: 'okrTree',
                  component: ManageOkrTree
                }
              ]
            },
            {
              path: 'okrSelect',
              name: 'ManageOkrSelect',
              component: ManageOkrSelect
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/reset',
      name: 'Reset',
      component: Reset
    },
    {
      path: '/loginbyadfs',
      // path: '/loginbyadfs/:token',
      name: 'LoginByADFS',
      component: LoginByADFS
    },
    {
      path: '/_webview',
      redirect: '/_webview/index',
      name: 'WebView',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'index',
          name: 'webviewIndex',
          component: WebViewIndex
        },
        {
          path: 'terms/ja',
          name: 'webviewTermsJA',
          component: (project === 'trendmicro') ? WebViewTermsTrendmicroJA : (project === 'trendmicroNg') ? WebViewTermsTrendmicroNgJA : WebViewTermsJA
        },
        {
          path: 'terms/en',
          name: 'webviewTermsEN',
          component: (project === 'trendmicro') ? WebViewTermsTrendmicroEN : (project === 'trendmicroNg') ? WebViewTermsTrendmicroNgEN : WebViewTermsEN
        },
        {
          path: 'terms/zh',
          name: 'webviewTermsZH',
          component: (project === 'trendmicro') ? WebViewTermsTrendmicroZH : (project === 'trendmicroNg') ? WebViewTermsTrendmicroNgZH : WebViewTermsZH
        },
        {
          path: 'helps/ja',
          name: 'webviewHelpsJA',
          component: WebViewHelpsJA
        },
        {
          path: 'helps/en',
          name: 'webviewHelpsEN',
          component: WebViewHelpsEN
        },
        {
          path: 'helps/zh',
          name: 'webviewHelpsZH',
          component: WebViewHelpsZH
        },
        {
          path: 'helps/lite/ja',
          name: 'liteWebviewHelpsJA',
          component: LiteWebViewHelpsJA
        },
        {
          path: 'helps/lite/en',
          name: 'liteWebviewHelpsEN',
          component: LiteWebViewHelpsEN
        },
        {
          path: 'helps/lite/zh',
          name: 'liteWebviewHelpsZH',
          component: LiteWebViewHelpsZH
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  let currentUser = firebaseApp.auth().currentUser
  let userInfo = store.getters.getCurrentUserInfo
  console.log('router:beforeEach:currentUser:', currentUser, 'userInfo', userInfo, 'to', to, 'from', from, 'next', next)
  if (requiresAuth && !currentUser) {
    console.log('router:beforeEach: Force to Login')
    next({ name: 'Login' })
  } else if (currentUser && !currentUser.displayName && userInfo && userInfo.userName && from.name === 'ProfileRegist' && to.name !== routeRegistPath) {
    console.log('router::force to okrlist without displayName for first time')
    next({ name: routeRegistPath })
  } else if (currentUser && !currentUser.displayName && !(userInfo && userInfo.userName) && to.name !== 'ProfileRegist' && !(to.params && to.params.registed)) {
    console.log('router:beforeEach: Force to ProfileRegist')
    next({ name: 'ProfileRegist' })
  } else if (currentUser && (currentUser.displayName || (userInfo && userInfo.userName)) && to.name === 'ProfileRegist') {
    console.log('router:beforeEach: Already ProfileRegist, Force to Profile')
    next({ name: 'Profile' })
  } else if (!requiresAuth && currentUser) {
    console.log('router:no requiresAuth and currentUser')
    next()
  } else {
    console.log('router:good')
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js